import { createModule } from '../../createModule';
import { parseInput } from '../../shared';
import * as ShareclassesSchemas from './shareclasses.schemas';
export const createShareclassesAPI = createModule(({ http }) => {
    return {
        get: async (params) => {
            const res = await http.get('/v2/shareclasses/', { params });
            return res;
        },
        create: async (body) => {
            const params = parseInput(ShareclassesSchemas.createShareclassSchema, body);
            const res = await http.post('/v2/shareclasses/', { body: params });
            return res;
        },
    };
});
